module.exports = __webpack_public_path__ + "img/ci.d83ba5db.svg";